import { z } from 'zod';
import { getJson, sendJson } from '@/shared/api/client';
import { pageSchema } from '@/shared/api/page';

export const deskQuestionSchema = z.object({
  id: z.string(),
  question: z.string(),
  /** The chat's earlier questions, so the analyst sees the thread. */
  context: z.array(z.string()),
  channel: z.enum(['portal', 'teams']),
  askedBy: z.string(),
  status: z.enum(['open', 'answered']),
  answer: z.string().nullable(),
  answeredBy: z.string().nullable(),
  createdAt: z.string(),
  answeredAt: z.string().nullable(),
  /** When the bot posted the reply in the asker's Teams chat; a portal asker sees it on their next look. */
  deliveredAt: z.string().nullish().default(null),
});
export type DeskQuestion = z.infer<typeof deskQuestionSchema>;

export type DeskParams = { page: number; pageSize: number; status: string };

export const askDesk = (question: string, context: string[]) => sendJson('post', '/desk-questions', deskQuestionSchema, { question, context });

export const fetchDeskQuestions = (params: DeskParams, signal?: AbortSignal) =>
  getJson('/desk-questions', pageSchema(deskQuestionSchema), { params, ...(signal ? { signal } : {}) });

export const fetchDeskQuestion = (id: string, signal?: AbortSignal) =>
  getJson(`/desk-questions/${id}`, deskQuestionSchema, signal ? { signal } : {});

export const answerDesk = (id: string, text: string) => sendJson('post', `/desk-questions/${id}/answer`, deskQuestionSchema, { text });
